import { render, staticRenderFns } from "./AdminPlanEdit.vue?vue&type=template&id=4b615550&scoped=true"
import script from "./AdminPlanEdit.vue?vue&type=script&lang=js"
export * from "./AdminPlanEdit.vue?vue&type=script&lang=js"
import style0 from "./AdminPlanEdit.vue?vue&type=style&index=0&id=4b615550&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b615550",
  null
  
)

export default component.exports